import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getActiveClient } from 'shared/store/clients/selectors'
import { useSelector } from 'react-redux'
import { useFetchServiceNewsQuery } from 'shared/store/publications/publications.service'
import { Banner, useIsMobile } from '@bbl-digital/snorre-v2'
import { cn } from 'shared/utils/cn'

export const ServiceMessage: React.FC = () => {
  const activeClient = useSelector(getActiveClient)
  const { data, isLoading, isError } = useFetchServiceNewsQuery()
  const isMobile = useIsMobile()

  const [isOpen, setIsOpen] = useState<boolean>(true)

  useEffect(() => {
    if (activeClient) {
      setIsOpen(true)
    }
  }, [activeClient])

  if (!isOpen || isError || isLoading || !data) return

  return (
    <Banner
      variant="warning"
      closeButton="Lukk driftsmelding"
      className={cn(
        'box-border w-auto mb- max-w-[1550px] mb-1',
        isMobile ? 'mx-2' : 'mx-4'
      )}
      withBorder
    >
      <Banner.Header className="!text-[18px] font-bold">
        Driftsmelding: {data.title}
      </Banner.Header>
      <Banner.Block className="flex flex-col ">
        {!!data.ingress && data.ingress}
        <Link
          to={`/boligbyggelaget/nyheter/${data.publicationId}`}
          onClick={() => setIsOpen(false)}
          className="underline"
        >
          Les mer
        </Link>
      </Banner.Block>
    </Banner>
  )
}
